import { render, staticRenderFns } from "./ConfigurazioneGeneralePazientiMenuListComponent.vue?vue&type=template&id=2365fc2c"
import script from "./ConfigurazioneGeneralePazientiMenuListComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneGeneralePazientiMenuListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports